import { fromJS } from 'immutable';

import {ApiDashboard, UserToken} from '../../../helper/HelperAuth'
import { GetBatchName } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (sender, templateName ,type = null) => async (dispatch, getState) => {
        const Authorization = UserToken;

        const url = ApiDashboard + 'list-batchname';

        var query = {
            "sender": sender,
            "templatename":templateName
        };

        console.log(query)

        const argument = {
            method: 'POST',
            headers : {
                'Content-Type':'application/json',
                'Authorization': Authorization,
                'template-type':type
            },
            body : JSON.stringify(query)
        };

        const response = await doFetch(url,argument);
        var data = fromJS({});
        if(response.ok){
            data = fromJS(await response.json());
            data = data.get('batchname');
        }

        dispatch({ type: GetBatchName, data: fromJS(data) });
};